export enum NotificationScreen {
  LOGIN = 'LOGIN',
  DASHBOARD = 'DASHBOARD',
}
